// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ArticleMenu{margin-bottom:1.5rem}@media(min-width:768px){.ArticleMenu{position:fixed;position:sticky;top:1rem}}.ArticleMenu__title{color:#1a1a1a;display:inline-block;font-family:\"Oswald\",sans-serif;font-size:1.125rem;font-weight:500;margin-bottom:1rem;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
